import type { ReactNode } from 'react';

const Role = {
  Admin: 'Admin', // SuperAdmin
  User: 'User',
  LabAdmin: 'LabAdmin'
} as const;

type Role = (typeof Role)[keyof typeof Role];

interface IMenu {
  to: string;
  label: string;
  roles: Role[];
  isMenu: boolean;
  subMenu?: IMenu[];
  icon: ReactNode;
  menuPaths: string[];
}

interface RoleProtectedProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

const FieldTypeDto = Object.freeze({
  MultiSelect: 11,
  SingleSelect: 12,
  Text: 13,
  SingleDimension: 14,
  MultipleDimension: 15,
  Numeric: 16,
  Percentage: 17,
  Date: 18,
  DateTime: 19,
  StaticText: 20
});

export { FieldTypeDto, Role, RoleProtectedProps };
export type { IMenu };
